export const ENTER_KEY = 'Enter';
export const DOWN_ARROW_KEY = 'ArrowDown';
export const UP_ARROW_KEY = 'ArrowUp';
export const LEFT_ARROW_KEY = 'ArrowLeft';
export const RIGHT_ARROW_KEY = 'ArrowRight';
